module.exports = __webpack_public_path__ + "img/badge-3.48e88db7.png";